import { Injectable } from '@angular/core';

import {
  IEntityConfig,
  ENTITY_TYPES,
  BackendApiType,
  IAuditLog,
} from '@app/shared/types';
import { Observable } from 'rxjs';

import { BaseService } from '../base';

const entityType: ENTITY_TYPES = ENTITY_TYPES.AUDIT_TRAIL;
const config: IEntityConfig = {
  backendApiType: BackendApiType.AUDIT_TRAIL,
  ENTITY_TYPE: entityType,
  isMasterListAvailable: false,
  apiEndpoint: entityType,
  uiRoute: entityType,
  customEntityRoute: {},
  buttons: {},
};

@Injectable()
export class AuditTrailService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;

  public getDocumentHistoryById(
    entityName: string,
    id: string,
  ): Observable<{ items: IAuditLog[] }> {
    return this.http
      .get<{ items: IAuditLog[] }>(`/${entityName}/history/${id}`, {
        params: this.createParams(),
      })
      .pipe(this.catchHttpError());
  }
}
